import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Intro } from '../components/sections/Intro';
import { RouteSteps } from '../components/sections/RouteSteps';
import { BeforeAfter } from '../components/sections/BeforeAfter';
import { Situations } from '../components/sections/Situations';
import { Volumes } from '../components/sections/Volumes';
import { Toolkit } from '../components/sections/Toolkit';
import { Bonuses } from '../components/sections/Bonuses';
import { Offer } from '../components/sections/Offer';
import { Guarantee } from '../components/sections/Guarantee';
import { Testimonials } from '../components/sections/Testimonials';
import { Creator } from '../components/sections/Creator';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
import { FloatingCTA } from '../components/FloatingCTA';
import { PurchasePopup } from '../components/PurchasePopup';
const FIRST_CTA_ID = 'first-cta';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-319" data-mp="33k90xu0vcfbe">
      <Hero ctaId={FIRST_CTA_ID} data-id="element-320" data-mp="33ift4beirp1t" />
      <main data-id="element-321" data-mp="38jvb1ulehffz">
        <Intro data-id="element-322" data-mp="38jd7se0bm0yk" />
        <RouteSteps data-id="element-323" data-mp="38itpgw6rdak0" />
        <BeforeAfter data-id="element-324" data-mp="38iaksh64cinx" />
        <Situations data-id="element-325" data-mp="38hsh4zh4n25z" />
        <Volumes data-id="element-326" data-mp="3dav9x5e2y7l4" />
        <Toolkit data-id="element-327" data-mp="3dbdf4ripzw56" />
        <Bonuses data-id="element-328" data-mp="3dbwlrc2x6y3w" />
        <Offer data-id="element-329" data-mp="3dceqyy7k8mny" />
        <Guarantee data-id="element-330" data-mp="3dc6ayxg5518j" />
        <Testimonials data-id="element-331" data-mp="3i9y4tx0cixfd" />
        <Creator data-id="element-332" data-mp="3i8dbubtojmjm" />
        <FAQ data-id="element-333" data-mp="3i8wq9ik4fssw" />
        <FinalCTA data-id="element-334" data-mp="3ibj05ouhikea" />
      </main>
      <Footer data-id="element-335" data-mp="3n89g8c6ahfzp" />
      <FloatingCTA anchorId={FIRST_CTA_ID} data-id="element-336" data-mp="3n7q8foacs7ze" />
      <PurchasePopup data-id="element-337" data-mp="3n6omgorsu12w" />
    </div>;
}